import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/svg/free-proxy-list.svg'


const _withScopeId = n => (_pushScopeId("data-v-5924d584"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col-lg-4 col-md-6 col-12" }
const _hoisted_2 = { class: "itemcard downloadcard" }
const _hoisted_3 = ["href"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Socks5 Proxies", -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Last updated: ")
const _hoisted_8 = { id: "socks5lastupdated" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = { id: "socks5proxyamount" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" proxies ")
const _hoisted_12 = { class: "selectors" }
const _hoisted_13 = { for: "socks5timeoutslide" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Timeout: ")
const _hoisted_15 = { id: "socks5timeoutoutput" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("ms")
const _hoisted_17 = {
  class: "nice-select selectortypes",
  tabindex: "0"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Country: "),
  /*#__PURE__*/_createElementVNode("span", { class: "current" }, "all")
], -1))
const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<li data-value=\"all\" class=\"option\" data-v-5924d584>all</li><li data-value=\"US\" class=\"option\" data-v-5924d584>US</li><li data-value=\"RU\" class=\"option\" data-v-5924d584>RU</li><li data-value=\"DE\" class=\"option\" data-v-5924d584>DE</li><li data-value=\"FR\" class=\"option\" data-v-5924d584>FR</li><li data-value=\"CN\" class=\"option\" data-v-5924d584>CN</li>", 6)
const _hoisted_25 = [
  _hoisted_19
]
const _hoisted_26 = /*#__PURE__*/_createStaticVNode("<div class=\"nice-select selectortypes\" tabindex=\"0\" data-v-5924d584><span data-v-5924d584>Anonymity: <span class=\"current\" data-v-5924d584>only for http proxies</span></span><ul class=\"list\" data-v-5924d584><li data-value=\"only for http proxies\" class=\"option selected\" data-v-5924d584> only for http proxies </li></ul></div><div class=\"nice-select selectortypes\" tabindex=\"0\" data-v-5924d584><span data-v-5924d584>SSL: <span class=\"current\" data-v-5924d584>only for http proxies</span></span><ul class=\"list\" data-v-5924d584><li data-value=\"only for http proxies\" class=\"option selected\" data-v-5924d584> only for http proxies </li></ul></div>", 2)
const _hoisted_28 = { class: "downloadbtn" }
const _hoisted_29 = ["href"]
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" or ")
const _hoisted_31 = ["href"]

import { socks5State } from '@/composables/free-proxies';
import FreeProxies from '@/services/api/fproxy-service';
import nProgress from 'nprogress';
import { onUnmounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  async setup(__props) {

let __temp: any, __restore: any

/* eslint-disable @typescript-eslint/no-explicit-any */

const url = 'https://api.proxyscrape.com/v2/';
const proxyInfo = async () => {
  const proxyInf = await FreeProxies.proxyInfoSocks5();
  socks5State.proxy_info.proxy_count = proxyInf.data.proxy_count;
  socks5State.proxy_info.last_updated = proxyInf.data.last_updated;
};
;(
  ([__temp,__restore] = _withAsyncContext(() => proxyInfo())),
  await __temp,
  __restore()
);

const onTimeout = () => {
  proxyInfo();
};
const getCountry = (click: any) => {
  socks5State.country = click.target.outerText;
  proxyInfo();
};

const onDownload = () => {
  nProgress.start();
  setTimeout(() => {
    setTimeout(() => nProgress.done(), 400);
  }, 300);
};

onUnmounted(() => {
  socks5State.getproxies = 'getproxies';
  socks5State.type = 'socks5';
  socks5State.timeout = 10000;
  socks5State.country = 'all';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        href: `${url}?request=getproxies&protocol=socks5&timeout=${_unref(socks5State).timeout}&country=${_unref(socks5State).country}`,
        onClick: onDownload
      }, _hoisted_6, 8, _hoisted_3),
      _createElementVNode("p", null, [
        _hoisted_7,
        _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(socks5State).proxy_info.last_updated), 1),
        _hoisted_9,
        _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(socks5State).proxy_info.proxy_count), 1),
        _hoisted_11
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("label", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(socks5State).timeout), 1),
          _hoisted_16
        ]),
        _withDirectives(_createElementVNode("input", {
          type: "range",
          step: "50",
          min: "50",
          max: "10000",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(socks5State).timeout) = $event)),
          onChange: onTimeout,
          class: "slider",
          id: "socks5timeoutslide"
        }, null, 544), [
          [_vModelText, _unref(socks5State).timeout]
        ]),
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("ul", {
            class: "list socks5country countryselect",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (getCountry($event)))
          }, _hoisted_25)
        ]),
        _hoisted_26
      ]),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("a", {
          href: `${url}?request=getproxies&protocol=socks5&timeout=${_unref(socks5State).timeout}&country=${_unref(socks5State).country}`,
          style: {"cursor":"pointer"},
          class: "save-btn",
          onClick: onDownload
        }, "Download", 8, _hoisted_29),
        _hoisted_30,
        _createElementVNode("a", {
          href: `${url}?request=share&protocol=socks5&timeout=${_unref(socks5State).timeout}&country=${_unref(socks5State).country}`,
          style: {"cursor":"pointer"}
        }, "Share", 8, _hoisted_31)
      ])
    ])
  ]))
}
}

})